var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("导出表格")]),
      _c(
        "div",
        { staticClass: "d2-mb" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.exportCsv } },
            [
              _c("d2-icon", { attrs: { name: "download" } }),
              _vm._v(" 导出 CSV ")
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.exportExcel } },
            [
              _c("d2-icon", { attrs: { name: "download" } }),
              _vm._v(" 导出 Excel ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        _vm._b(
          { staticStyle: { width: "100%" } },
          "el-table",
          _vm.table,
          false
        ),
        _vm._l(_vm.table.columns, function(item, index) {
          return _c("el-table-column", {
            key: index,
            attrs: { prop: item.prop, label: item.label }
          })
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }